import { Directive } from "vue"

const directive: Directive = {
    mounted(el, node) {
        const $el = $(el);

        // Binding del click
        $el.on("click", function () {
            const parent = $(this).parent();
            const content = parent.find(".departures-exp");

            content.stop(true, true).slideToggle(() => {
                const isVisible = content.is(":visible");
                parent.find(".button").attr("data-selected", isVisible ? "True" : "False");
            });
        });
    }
};

export default directive;